/* eslint-disable @typescript-eslint/no-explicit-any */
import { IIdentity } from 'azure-devops-extension-api/Identities';
import { searchIdentities } from 'src/azure/services/get-board-users';

export const identitiesList = () => {
	const users = new Map<string, IIdentity>();
	return {
		search: async (id: string) => {
			if (!users.has(id)) {
				const foundIdentities = await searchIdentities(id, { withGroup: true, queryTypeHint: 'uid' });
				const foundIdentity: any = foundIdentities.find((item) => (item as IIdentity & { localId: string }).localId === id);
				users.set(id, foundIdentity);
			}
		},
		getList: () => {
			return Array.from(users.values());
		},
		getIdentity: (id: string) => {
			return users.get(id) as IIdentity;
		}
	};
};